import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../createAppAsyncThunk';
import { API_POST } from '../../../services';
import { PerformanceLLMGrid } from '../../../models/PerformanceLLMGridModel';
import type { RootState } from '../../store';
import { env } from '../../../env';
import { ENDPOINTS } from '../../../constants/endPoints';
import { RADRequest } from '../../../models/common/RADRequest';

interface LocalLiftMaxState {
  data: PerformanceLLMGrid | null;
  isLoading: boolean;
}

const initialState: LocalLiftMaxState = {
  data: null,
  isLoading: false,
};

// Async thunk to fetch Local Lift Max data
export const fetchLocalLiftMaxData = createAppAsyncThunk(
  'localLiftMax/fetchLocalLiftMaxData',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode,
    };

    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_LOCAL_LIFT_MAX_DATA}`,
      requestBody,
    );
    return response as PerformanceLLMGrid;
  },
);

// Local Lift Max slice
const localLiftMaxSlice = createSlice({
  name: 'localLiftMax',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchLocalLiftMaxData.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchLocalLiftMaxData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchLocalLiftMaxData.rejected, state => {
        state.data = null;
        state.isLoading = false;
      });
  },
});

// Selectors
export const selectLocalLiftMaxData = (state: RootState) => state.localLiftMax.data;
export const selectLocalLiftMaxLoading = (state: RootState) => state.localLiftMax.isLoading;

export default localLiftMaxSlice.reducer;
